import React, { useEffect } from "react";
import { Modal, Form, Select, Button } from "antd";

const { Option } = Select;

interface AddNewMarketModalProps {
  open: boolean;
  onCancel: () => void;
  onSubmit: (values: { market: string }) => void;
  markets: string[];
  initialValue?: string;
  loading?: boolean;
}

const AddNewMarketModal: React.FC<AddNewMarketModalProps> = ({
  open,
  onCancel,
  onSubmit,
  markets,
  initialValue,
  loading = false,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
      form.resetFields();
    } catch (err) {
      // Validation failed
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      open={open}
      title="Add New Market"
      onCancel={handleCancel}
      footer={null}
      centered
      destroyOnClose
      width={400}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ market: initialValue || undefined }}
        onFinish={onSubmit}
      >
        <Form.Item
          label="Market Name"
          name="market"
          className="!p-[30px_0_10px]"
          rules={[
            { required: true, message: "Please select at least one market" },
          ]}
        >
          <Select mode="multiple" placeholder="Select market(s)">
            {markets.map((market: any) => (
              <Option key={market.id} value={market.id}>
                {market.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <div className="flex justify-end gap-2 mt-6">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className="!bg-[#0152FB]"
          >
            Save
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddNewMarketModal;
